import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';

import Field from 'core/components/form/form.v2';
import { SubRiskCollapsibleSection } from './sub-risk-collapsible-section';
import useStyles from './sub-risk.styles';

const CosmeticDamageExclusion = ({ fieldName, disabled }) => {
  const classes = useStyles();

  return (
    <SubRiskCollapsibleSection
      type="secondary"
      content={<div className={classes.headerText}>Cosmetic damage exclusion</div>}
      initialOpen={false}
    >
      <Grid container spacing={2}>
        <Field
          xs={4}
          type="checkbox"
          id={`${fieldName}.exteriorDoorsWindowsDamageExclusion`}
          name={`${fieldName}.exteriorDoorsWindowsDamageExclusion`}
          mode="dark"
          label="Exterior doors and windows"
          disabled={disabled}
        />
        <Field
          xs={4}
          type="checkbox"
          id={`${fieldName}.exteriorWallsDamageExclusion`}
          name={`${fieldName}.exteriorWallsDamageExclusion`}
          mode="dark"
          label="Exterior walls"
          disabled={disabled}
        />
        <Field
          xs={4}
          type="checkbox"
          id={`${fieldName}.roofsDamageExclusion`}
          name={`${fieldName}.roofsDamageExclusion`}
          mode="dark"
          label="Roofs"
          disabled={disabled}
        />
      </Grid>
    </SubRiskCollapsibleSection>
  );
};

CosmeticDamageExclusion.propTypes = {
  fieldName: PropTypes.string.isRequired,
  disabled: PropTypes.bool
};

CosmeticDamageExclusion.defaultProps = {
  disabled: false
};

export default observer(CosmeticDamageExclusion);
